<template>
    <div class="card mb-5" style="height: 440px !important; padding: 20px !important;">
        <div class="d-flex flex-row" style="gap: 20px;">
            <div class="card p-3 d-flex flex-column" style="width: 40%; height: 400px;">
                <h5>Popup Banner Image</h5>
                <input type="file" @change="handleFileChange" class="mb-2" accept=".jpg, .jpeg, .png">
                <input type="text" v-model="redirect_url" class="mb-2 form-control" placeholder="Redirect Url">
                <button @click.prevent="uploadFile" class="btn btn-success"><i class="fa fa-upload mr-2"></i>Upload</button>
            </div>
            <div class="card d-flex flex-column" style="width: 60%;">
                <img :src="image_url" height="400px" style="object-fit: contain !important;" alt="Image">
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            image_url: null,
            redirect_url: null,
            file: null
        }
    },
    mounted() { 
        this.fetchPopupFile()
    },
    methods: {
        async fetchPopupFile() {
            try {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetch_auto_banner_data',
                })
                if (response?.data?.data?.id) {
                    this.image_url = response?.data?.data?.image_url
                    this.redirect_url = response?.data?.data?.redirect_url
                }
            } catch (error) {
                console.log(error);
            }
        },
        async uploadFile() {
            try {
                if (!this.file) {
                    this.$toasted.global.error({
                        message: 'Select a file to upload.'
                    })
                    return
                }
                if (this.redirect_url) {
                    this.file.delete('redirect_link')
                    this.file.append('redirect_link', this.redirect_url)
                }
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=upload_auto_banner_data',
                    data: this.file
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.message
                })
            } catch (error) {
                console.log(error);
            }
        },
        handleFileChange(event) { 
            this.file = new FormData()
            this.file.append('file', event.target.files[0])
            this.image_url = URL.createObjectURL(event.target.files[0])
        },
    }
}
</script>